<template>
  <span>
    <span v-if="hasValue">
      {{ formattedValue }}
    </span>
    <span
      v-else
      class="font-italic"
    > No value </span>
  </span>
</template>

<script>
import DownloadDocumentFile from '@/mixins/DownloadDocumentFile'

export default {
  name: 'AssetValueDisplay',
  components: {},
  mixins: [DownloadDocumentFile],
  props: {
    asset: { type: Object, required: true }
  },
  computed: {
    hasValue() {
      return this.value > 0
    },
    value() {
      return this.asset.assetValue
    },
    currency() {
      return this.asset.currencyType
    },
    formattedValue() {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.currency }).format(this.value)
    }
  }
}
</script>
<style lang="scss" scoped></style>
